import { render, staticRenderFns } from "./RemoteOperation.vue?vue&type=template&id=42fc8706&lang=pug&"
import script from "./RemoteOperation.vue?vue&type=script&lang=ts&"
export * from "./RemoteOperation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports